import ListButton from '@/ui/components/list-button';
import type { TokenItemProps } from '@/ui/components/token-item';
import TokenItem from '@/ui/components/token-item';
import { cn } from '@/ui/utils/classnames';

type BaseItemProps = TokenItemProps & {
  dataTestId?: string;
  onClick: () => void;
};

function BaseItem({
  name,
  displayName,
  itemName,
  displayTicker,
  chainName,
  balance,
  fiatValue,
  price,
  stackedIcon,
  loading,
  className,
  dataTestId,
  onClick,
}: BaseItemProps) {
  return (
    <ListButton onClick={onClick} dataTestId={dataTestId}>
      <TokenItem
        name={name}
        displayName={displayName}
        itemName={itemName}
        displayTicker={displayTicker}
        balance={balance}
        fiatValue={fiatValue}
        chainName={chainName}
        price={price}
        stackedIcon={stackedIcon}
        loading={loading}
        className={cn('py-4', className)}
      />
    </ListButton>
  );
}

export default BaseItem;
